import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreTo,
  moreLabel = '查看更多',
}: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="font-label text-xs tracking-[0.25em] uppercase text-accent-600">{eyebrow}</span>
        )}
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2">{title}</h2>
        {description && <p className="mt-2 text-sm text-foreground-600 max-w-2xl">{description}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="group flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}